import {
  Box,
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

/**
 * The component within the about page to show Jim's bio
 */
const JimBio = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box paddingY="3em">
      <Grid container spacing={6}>
        <Grid item md={12} sm={12}>
          <Box
            display="flex"
            justifyContent="center"
            margin={3}
            sx={{
              float: isMd ? 'right' : 'initial',
            }}
          >
            <Card
              sx={{
                padding: 0,
                height: '20em',
                width: '15em',
              }}
            >
              <img
                style={{
                  height: '100%',
                  maxWidth: '100%',
                  objectFit: 'cover',
                  objectPosition: '70%',
                  margin: 0,
                  padding: 0,
                }}
                src="jim-profile.png"
                alt="Picture of Jim Warwick, Founder of S3G"
              />
            </Card>
          </Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              display: 'inline',
            }}
          >
            Jim Warwick, Ed. D.
          </Typography>
          <br />
          <Typography
            sx={{
              textTransform: 'uppercase',
              fontWeight: 'medium',
              marginBottom: '1em',
              display: 'inline',
            }}
            color="textSecondary"
          >
            Founder of S3G
          </Typography>
          <Typography variant="h6" component="p">
            <br />
            With over 26 years in law enforcement, Jim Warwick has dedicated his
            career to training others to survive life-or-death situations. As a
            Senior Weapons and Tactics Instructor, his experience spans Patrol,
            K-9 Division, Special Operations Response Team, and more, giving him
            unparalleled insight into how people react to fear and navigate
            crisis scenarios.
            <br />
            <br />
            Since 2006, Jim has trained thousands on active shooter response and
            workplace violence prevention, combining his real-world expertise
            with academic leadership as an Associate Professor and Director of
            Criminal Justice Programs. Driven to make this critical knowledge
            accessible to more people, he developed online training programs
            that empower organizations to promote safety and preparedness.
            <br />
            <br />
            Jim holds a Doctorate in Organizational Learning, Leadership, and
            Innovation, with research focused on preparedness for stopping
            active shooter events. He is a Certified Firearms Instructor, Master
            Police Instructor, Interactive Use of Force Instructor, Low-Light
            Strategies Instructor, Realistic De-Escalation Instructor, and a
            Force Science Analyst.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JimBio;
